import Form from './Form';
import Collection from 'Support/Collection';

export default class OrgsListForm extends Form {
    templateId() {
        return '#orgsListFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/getOrgs';
    }

    process() {
        return function (data) {
            data.orgs.sort(function compare(a, b) {
                if (a.organizationName < b.organizationName) {
                    return -1;
                }
                if (a.organizationName > b.organizationName) {
                    return 1;
                }
                return 0;
            });
            return { title: 'Organizations', items: Collection.collect(data.orgs).itemsOrNone() };
        };
    }
}
